export const load = () => ({
	title: 'DIY Guide to Soundproofing Your Own Windows',
	showTitle: true,
});
